import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import Explore from './pages/Explore'
import Enquire from './pages/Enquire'
import Gallery from './pages/Gallery'
import TripDetails from './pages/TripDetails'

export default function App(){
  return (
    <div>
      <Header />
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/explore" element={<Explore/>} />
        <Route path="/enquire" element={<Enquire/>} />
        <Route path="/gallery" element={<Gallery/>} />
        <Route path="/trips/:slug" element={<TripDetails/>} />
      </Routes>
      <Footer />
    </div>
  )
}
